// VITE_RUNTIME_ENV is only used in development - in the container we use __RUNTIME_ENV__
export const ENVIRONMENT = import.meta.env.VITE_RUNTIME_ENV || "__RUNTIME_ENV__";
export const SENTRY_ENABLE = import.meta.env.VITE_SENTRY_ENABLE || "__SENTRY_ENABLE__";
export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN || "__MAPBOX_TOKEN__";
export const OCTALOG_VERSION = import.meta.env.VITE_OCTALOG_VERSION || "__OCTALOG_VERSION__";
